import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import activitiesReducer from './slices/activitiesSlice';
import authReducer from './slices/authSlice';
import checklistReducer from './slices/checklistSlice';
import eoUiReducer from './slices/eoUiSlice';
import eventsReducer from './slices/eventsSlice';
import participantsReducer from './slices/participantsSlice';
import partnersReducer from './slices/partnersSlice';
import posterReducer from './slices/posterSlice';
import profileReducer from './slices/profileSlice';
import discoveryReducer from './slices/discoverySlice';
import publicProfileReducer from './slices/publicProfileSlice';
import { rootSaga } from './sagas/rootSaga';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    auth: authReducer,
    eoUi: eoUiReducer,
    events: eventsReducer,
    activities: activitiesReducer,
    participants: participantsReducer,
    partners: partnersReducer,
    checklist: checklistReducer,
    poster: posterReducer,
    profile: profileReducer,
    discovery: discoveryReducer,
    publicProfile: publicProfileReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        ignoredActions: [
          'profile/profileAvatarUploadRequested',
          'profile/profileBackgroundUploadRequested',
          'profile/profileComponentImageUploadRequested',
          'profile/profileComponentImageRemoveRequested',
        ],
        ignoredActionPaths: ['payload.file'],
      },
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
